import React, { FC, useEffect } from 'react';
import LoggedInApp from './LoggedInApp';
import LoggedOutApp from './LoggedOutApp';
import AutoLoginApp from './AutoLoginApp';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { setTargetURI, setJwt, setUser } from 'src/modules/shared/slices/auth/entity/AuthSlice';
import { useRequestMeMutation } from 'src/modules/shared/slices/auth/entity/api/auth';

export function getTokenFromQuery(queryString: string) {
  const params: { token?: string; target_uri?: string } = {};
  const query = queryString.substring(1);
  const pairs = query.split('&');

  pairs.forEach((pair: string) => {
    const [key, value] = pair.split('=');
    if (key === 'token' || key === 'target_uri') {
      params[key] = decodeURIComponent(value || '');
    }
  });

  return params;
}

const AuthorizationRoot: FC = () => {
  const jwt = useAppSelector((state) => state.auth.jwt);
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();
  const [requestMe, { data: meResponse, isUninitialized }] = useRequestMeMutation({
    fixedCacheKey: '/me',
  });

  const { token, target_uri } = getTokenFromQuery(window.location.search);

  useEffect(() => {
    if (token) dispatch(setJwt(token));
    if (target_uri) dispatch(setTargetURI(target_uri));
  }, [dispatch, target_uri, token]);

  useEffect(() => {
    if (isUninitialized && jwt) requestMe();
  }, [requestMe, isUninitialized, jwt]);

  useEffect(() => {
    if (meResponse) dispatch(setUser(meResponse));
  }, [meResponse, dispatch]);

  return jwt ? (
    user ? (
      !!user.privacyAcceptedAt ? (
        <LoggedInApp />
      ) : (
        <LoggedOutApp />
      )
    ) : (
      <AutoLoginApp />
    )
  ) : (
    <LoggedOutApp />
  );
};

export default AuthorizationRoot;
